import { BaseInteraction } from './base';
/**
 * Interaction handler for hovering nodes and relationships.
 *
 * For examples, head to the {@link https://neo4j.com/docs/nvl/current/interaction-handlers/#_hoverinteraction Hover Interaction documentation page}.
 */
export class HoverInteraction extends BaseInteraction {
    currentHoveredElementId = undefined;
    currentHoveredElementIsNode = undefined;
    updates = {
        nodes: [],
        relationships: []
    };
    constructor(nvl, options = { drawShadowOnHover: false }) {
        super(nvl, options);
        this.addEventListener('mousemove', this.handleHover, true);
    }
    /**
     * Handle mouse hover events
     * @param {MouseEvent} event - The mouse event
     */
    handleHover = (event) => {
        const { nvlTargets } = this.nvlInstance.getHits(event);
        const { nodes = [], relationships = [] } = nvlTargets;
        const mainTarget = nodes[0] ?? relationships[0];
        const hoveredElement = mainTarget?.data;
        const newHoveredElementIsNode = hoveredElement !== undefined && nodes[0] !== undefined;
        const nothingHasBeenHoveredOrUnHovered = this.currentHoveredElementId === undefined && hoveredElement === undefined;
        const newHoveredElementIsTheSameAsCurrent = hoveredElement?.id !== undefined &&
            this.currentHoveredElementId === hoveredElement.id &&
            newHoveredElementIsNode === this.currentHoveredElementIsNode;
        if (nothingHasBeenHoveredOrUnHovered || newHoveredElementIsTheSameAsCurrent) {
            this.callCallbackIfRegistered('onHover', hoveredElement, nvlTargets, event);
            return;
        }
        const currentElementNeedsUnHover = this.currentHoveredElementId !== undefined && this.currentHoveredElementId !== hoveredElement?.id;
        if (currentElementNeedsUnHover) {
            this.unHoverCurrentElement();
        }
        if (newHoveredElementIsNode) {
            this.updates.nodes.push({ id: hoveredElement.id, hovered: true });
            this.currentHoveredElementId = hoveredElement.id;
            this.currentHoveredElementIsNode = true;
        }
        else if (hoveredElement !== undefined) {
            const { id } = hoveredElement;
            this.updates.relationships.push({ id, hovered: true });
            this.currentHoveredElementId = hoveredElement.id;
            this.currentHoveredElementIsNode = false;
        }
        else {
            this.currentHoveredElementId = undefined;
            this.currentHoveredElementIsNode = undefined;
        }
        this.callCallbackIfRegistered('onHover', hoveredElement, nvlTargets, event);
        this.updateElementsInNVL();
        this.clearUpdates();
    };
    updateElementsInNVL() {
        // Use pure update API to avoid the previous removed node to be re-added to the scene.
        if (this.currentOptions.drawShadowOnHover === true) {
            const currentNodes = this.nvlInstance.getNodes();
            if (currentNodes.length > 0) {
                this.nvlInstance.updateElementsInGraph(this.updates.nodes, this.updates.relationships);
            }
        }
    }
    clearUpdates() {
        this.updates.nodes = [];
        this.updates.relationships = [];
    }
    unHoverCurrentElement() {
        if (this.currentHoveredElementId === undefined) {
            return;
        }
        const update = {
            id: this.currentHoveredElementId,
            hovered: false
        };
        if (this.currentHoveredElementIsNode === true) {
            this.updates.nodes.push(update);
        }
        else {
            this.updates.relationships.push({ ...update });
        }
    }
    destroy() {
        this.removeEventListener('mousemove', this.handleHover, true);
    }
}
